import { ModalForm, TalentechFormFieldTypes } from "@talentech/components";
import { toast } from "react-toastify";
import { useUpdateTemplateNameMutation } from "@/redux/reducer/pages.api";

interface TemplateEditModalProps {
  show: boolean;
  onClose: () => void;
  templateId: string;
  templateName: string;
}

const TemplateEditModal: React.FC<TemplateEditModalProps> = ({
  show, 
  onClose, 
  templateId, 
  templateName
}) => {
  const [updateTemplateName] = useUpdateTemplateNameMutation();

  const handleSubmit = (data: { form: { name: string } }) => {
    const promise = updateTemplateName({
      id: templateId,
      name: data.form.name
    }).unwrap();

    toast.promise(promise, {
      pending: "Updating template name...",
      success: "Template name updated successfully",
      error: "Failed to update template name"
    })
    .then(() => {
      onClose();
    });
  };

  const modalProps = {
    title: "Edit Template Name",
    showModal: show,
    toggleModal: onClose,
  };

  const formProps = {
    handleSubmit,
    formFields: {
      section: "",
      id: "form",
      fields: [
        {
          field: "name",
          label: "Template Name",
          type: TalentechFormFieldTypes.TEXT,
          initialValue: templateName,
          placeholder: "Enter template name",
        },
      ],
    },
  };

  return (
    <ModalForm
      modal={modalProps}
      form={formProps}
    />
  );
};

export default TemplateEditModal;